import React, { useState, useEffect, useCallback, useRef } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch, useSelector } from "react-redux";
import { getAppSettings, getAppWorkflowState, RootState, setAppWorkflowState } from "../Redux/store";
import { Id, ToastContainer, toast } from "react-toastify";
import { useInterval } from 'usehooks-ts'
import { appWorkflowStates } from "../Types/appWorkflowStates";
import { cleanHLUserCookies, getCurrentCookiePath } from "../GlobalMethods";
import Cookies from "js-cookie";
import { FoundationsConstants } from "../FoundationsConstants";
import { FoundationsGenericToaster } from "../GenericComponents/FoundationsGenericToaster";

const fetchIdleTimeoutFromAPI = async () => {
  // Simulated API call (replace with real API call)
  return new Promise<number>((resolve) => {
    setTimeout(() => resolve(10 * 60 * 1000), 1000); // Example: 10 minutes
  });
};

/*
  idleTimeout: number; // idle time out in milliseconds
  idleWarning: string; // warning message to display when idle
  onIdle: () => void; // callback when idle
*/
const IdleWatcher = (props:{
  idleTimeout: number;
  warningMins: number;
  idleWarning:string
  onIdleCustom?: () => void;
}) => {
  const { idleTimeout, idleWarning, warningMins, onIdleCustom } = props;
  const dispatch = useDispatch();
  const [lastActiveTime, setLastActiveTime] = useState<number>(Date.now());
  const [showWarning, setShowWarning] = useState<boolean>(false);
  const appSettings: any = useSelector(
    (state: RootState) => { return getAppSettings(state) || {} }
    )
  const appWorkflowState = useSelector(
      (state: RootState) => getAppWorkflowState(state)
    )    
  // const idleTimeout = appSettings.tokenExpirationInterval * 60 * 1000; // Convert minutes to milliseconds
  //const idleTimeout = 3 * 60 * 1000; // Convert minutes to milliseconds

  const toastId = useRef<Id | null>(null);
  

  // Calculate pre-idle warning time (2 minutes before)
  const warningTime = warningMins * 60 * 1000; // 2 minutes before timeout

  useInterval(
    () => {
      if (getRemainingTime() <= warningTime && getRemainingTime() > 0) {
        setShowWarning(true);

        const message = `${idleWarning} ${Math.ceil(getRemainingTime() / 1000)} seconds. Move cursor to extend the session.`;

        if (toastId.current === null) {
          // First time: show the toast and store the ID
          toastId.current = FoundationsGenericToaster("error", message, {
            autoClose: false,
          });
        } else {
          // Update the same toast
          toast.update(toastId.current, {
            render: message,
            type: "error",
            autoClose: false,
          });
        }
      }
      else if (getRemainingTime() <= 2 && onIdleCustom === undefined) {
        cleanHLUserCookies()
        dispatch(setAppWorkflowState(appWorkflowStates.UNAUTHENTICATED));
      } else if (toastId.current !== null && getRemainingTime() <= 2 && onIdleCustom !== undefined) {
        onIdleCustom();
        FoundationsGenericToaster("clear", "", {}, toastId.current)
        setShowWarning(false);
      } else if (toastId.current !== null) {
        FoundationsGenericToaster("clear", "", {}, toastId.current)
        setShowWarning(false);
      }
    },
    // Delay in milliseconds or null to stop it
    appWorkflowState == appWorkflowStates.AUTHENTICATED ?
      showWarning ? 1000 : 5000 :
      null,
  )

  // When user actually goes idle
  const onIdle = useCallback(() => {

  }, []);

  // When user becomes active again
  const onActive = useCallback(() => {
    setLastActiveTime(Date.now());
    console.log("User is active again");
  }, []);

  // Setup Idle Timer
  const { getRemainingTime, reset, start  } = useIdleTimer({
    timeout: idleTimeout, // Convert minutes to milliseconds,
    crossTab: true,
    onIdle,
    onActive,
    onAction: () => { reset(); setLastActiveTime(Date.now()); },
    debounce: 500,
    startManually: true, // Important: Ensure the timer starts manually
    syncTimers: 200,
  });

  useEffect(() => {
    start(); // Ensure the timer starts
  }, [idleTimeout, start, appWorkflowState]);


  return (
    <div>
      <p className="small">Last Active on {new Date(lastActiveTime).toISOString()}</p>
    </div>
  );
};

export default IdleWatcher;
